import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ivory px-3 py-4 sm:px-6" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl gap-2.5 rounded-md border border-gold/60 bg-white p-3 shadow-sm" data-id="element-71" data-mp="1o3dnoel7yhs7">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-gold" strokeWidth={1.8} aria-hidden="true" data-id="element-72" data-mp="221bw73cuzjzs" />
        <div data-id="element-73" data-mp="19e7lqiuzydgm">
          <h2 className="font-heading text-[0.95rem] font-bold uppercase leading-tight text-navy sm:text-[1.25rem]" data-id="element-74" data-mp="19fsi8e0vg6h4">
            Your purchase is 100% protected
          </h2>
          <p className="mt-0.5 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-75" data-mp="1j52d21n3o38x">
            Explore CLINICAL LAB VISUAL ATLAS™ for 7 days. Discover the six
            modules, hematology patterns, chemistry correlations, microbiology
            visuals, immunology resources, urinalysis references, blood bank
            tools and five professional bonuses. If the system isn’t right for
            you, contact us within 7 days for a full refund according to the
            refund terms.
          </p>
        </div>
      </div>
    </section>;
}